import React from 'react';
import './StatusScreen.less';

const StatusScreen = ({ children, footer }) => {
  return (
    <div className="status-screen">
      <div className="status-content">
        {children}
      </div>
      {footer}
    </div>
  );
};

export default StatusScreen;
